module.exports = __webpack_public_path__ + "static/assets/a066c4f474bfa75d50bcb9527f931f41.png";